import { render, staticRenderFns } from "./SensorData.vue?vue&type=template&id=227e7be9&"
import script from "./SensorData.vue?vue&type=script&lang=js&"
export * from "./SensorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports